import { observer } from 'mobx-react';
import './manager-approval-modal.scss';
import { DefaultModalLayout } from '../components/modal/layouts/default-modal-layout';
import { BUTTON_VARIANTS } from '../components/inputs/button-variants';
import managerApprovalModalStore from './manager-approval-modal-store';
import ListLayout from '../components/layouts/list-layout/list-layout';
import FontBody1 from '../components/fonts/font-body1/font-body1';
import { SelectDropdown } from '../components/inputs/select-dropdown/select-dropdown';
import { FONT_COLOR, FONT_VARIANT } from '../components/fonts/font-props';
import { Input } from '../components/inputs/input/input';
import { IButtonProps } from '../components/inputs/button/button';
import { useEffect } from 'react';


/** GLOBAL COMPOPNENT
 * IMPORTANT: This component should not be directly added to any page, it is added to the project in App.tsx as global 
 * The usage should be done only from it's manager store "managerApprovalModalStore" 
 * managerApprovalModalStore is reponsible for the full management of this component, open/close etc.. */

export const ManagerApprovalModal: React.FC = observer(() => {

    const modalStore = managerApprovalModalStore;
    const managersList = modalStore.managersList;
    const credentialsStore = modalStore.credentialsStore;

    useEffect(() => {
        modalStore.registerComponent();
        return modalStore.unregisterComponent;
    }, [modalStore]);

    const handleClose = () => {
        modalStore.close();
    }

    const handleSubmit = () => {
        if (credentialsStore?.isSet()) {
            modalStore.submit();
        }
    }

    const buttons: IButtonProps[] = [
        {
            text: 'Cancel',
            variant: BUTTON_VARIANTS.Tertiary,
            onClick: handleClose,
            hasLoader: false,
        },
        {
            text: 'Approve',
            variant: BUTTON_VARIANTS.Primary,
            disabled: !credentialsStore?.isSet(),
            onClick: handleSubmit,
            hasLoader: true,
            isLoading: credentialsStore?.isValidating()
        }
    ];

    if (!credentialsStore) {
        return null;
    }

    return (
        <DefaultModalLayout
            isCloseDisabled={false}
            onCloseClicked={handleClose}
            buttons={buttons}
        >
            <div className="managers-approval-by-password-modal">
                <ListLayout>
                    <div className="managers-approval-modal-heading">
                        <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                            {`Manager’s Approval`}
                        </FontBody1>
                    </div>
                    <div className="managers-approval-modal-input-wrapper">
                        <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                            {'Manager Name'}
                        </FontBody1>
                        <SelectDropdown
                            placeholder={'Select manager'}
                            isLoading={managersList.isLoading}
                            options={managersList.getManagersOptionList()}
                            value={managersList.getSelectedManagerOption()}
                            onChange={(v) => managersList.setManagerId(v?.value as number)}
                        />
                    </div>
                    <div className="managers-approval-modal-input-wrapper">
                        <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                            {'Manager Password'}
                        </FontBody1>
                        <form onSubmit={(e) => { e.preventDefault(); }}> {/** the form is here to prevent browser from complaining about password field outside form */}
                        <Input
                            required={true}
                            type="password"
                            placeholder={'Enter password'}
                            value={credentialsStore.getPassword()}
                            onChange={credentialsStore.setPassword}
                            autoComplete="off"
                            onSubmit={handleSubmit}
                        />
                        </form>
                    </div>
                </ListLayout>
            </div>
        </DefaultModalLayout>
    );

});